const formatCents = (cents) => {
  const dollars = cents / 100;
  // Check if the value is a float
  if (!Number.isInteger(dollars / 1000)) {
    return dollars.toLocaleString();
  }

  return `${(dollars / 1000).toLocaleString()}k`;
};

export const displayCompensationPeriod = (compensation = {}) => {
  const {
    amountMinCents,
    amountMaxCents,
    currency,
    period,
    offersEquity,
    convertedAmountMinCents,
    convertedAmountMaxCents,
    convertedCurrency,
  } = compensation;
  const converted =
    convertedAmountMinCents && convertedAmountMaxCents && currency !== convertedCurrency
      ? ` (${convertedCurrency} ${formatCents(convertedAmountMinCents)}-${formatCents(
          convertedAmountMaxCents,
        )} / ${period.toLowerCase()})`
      : '';

  return `${currency} ${formatCents(amountMinCents)}-${formatCents(
    amountMaxCents,
  )} / ${period.toLowerCase()}${converted}${offersEquity ? ' + Equity' : ''}`;
};
